export default "__VITE_ASSET__d3fae1a8__"